import React from 'react';
import { OverviewTextAction } from './OverviewCardShell';
import styles from './StandardOverview.module.css';
import { OVERVIEW_DUMMY_FIELDS } from './overviewDummyFields';

/** Placeholder feed until project activity API exists (Figma: findings-ready overview). */
export const RECENT_ACTIVITY_PREVIEW = [
    { time: '10:42', actor: 'Maria Chen', action: 'uploaded security-architecture.pdf', workstream: 'Cybersecurity' },
    { time: '09:58', actor: 'Sarah Ahmed', action: 'answered IRL-24', workstream: 'Information Technology' },
    { time: '09:31', actor: 'James Carter', action: 'created a new observation', workstream: 'Commercial' },
    { time: 'Yesterday', actor: 'Lens', action: 'suggested 6 follow-up IRL questions', workstream: 'Information Requests' },
    { time: '2 days ago', actor: 'Maria Chen', action: 'uploaded application-inventory.xlsx', workstream: 'Information Technology' },
];

const RecentProjectActivityCard = ({ items = RECENT_ACTIVITY_PREVIEW, usesDummyData = true }) => (
    <section className={styles.activityCard} title={usesDummyData ? OVERVIEW_DUMMY_FIELDS.recentProjectActivity : undefined}>
        <div className={styles.activityHeader}>
            <p className={styles.cardEyebrow}>Recent Project Activity</p>
            <OverviewTextAction type="button" onClick={() => {}}>
                View activity →
            </OverviewTextAction>
        </div>
        <ul className={styles.activityList}>
            {items.map(row => (
                <li key={`${row.time}-${row.action}`} className={styles.activityRow}>
                    <span className={styles.activityTime}>{row.time}</span>
                    <div className={styles.activityBody}>
                        <p className={styles.activityText}>
                            <span className={styles.activityActor}>{row.actor} </span>
                            {row.action}
                        </p>
                        <p className={styles.activityWorkstream}>{row.workstream}</p>
                    </div>
                </li>
            ))}
        </ul>
    </section>
);

export default RecentProjectActivityCard;
